import { Order, State } from 'entities/orders';
import { useMemo } from 'react';
import { getDiffBetweenDates } from 'shared/lib/time';
import { BasicCircleButtonVariant } from 'shared/ui/buttons/iconButtons/circleButtons';
import { TopButtonsContainerVariants } from 'widgets/orderDetail/ui/types';

export const useOrderDetailHeaderTimer = (
	order: Order,
	variant: TopButtonsContainerVariants,
) => {
	const orderState = order.state;
	const visitEnd = order.appointment?.dt_visit_end;
	const visitStart = order.appointment?.dt_visit_start;

	const timer = useMemo(() => {
		const currentDate = new Date();
		const dateStart = new Date(order?.dt_start);

		if (currentDate.getTime() >= dateStart.getTime()) {
			const differenceObj = getDiffBetweenDates(currentDate, dateStart);

			if (differenceObj && differenceObj.minutes > 0) {
				const restMinutes = order.duration - differenceObj.minutes;

				if (restMinutes <= 0) {
					return '00:00';
				}

				const minutes = restMinutes % 60;

				return `${Math.floor(restMinutes / 60)}:${`0${minutes}`.slice(
					-2,
				)}`;
			}
		}

		return '00:00';
	}, [order]);

	const hasTimer =
		orderState === State.DELAY ||
		orderState === State.ENDING ||
		orderState === State.EXCEEDING ||
		orderState === State.BUSY ||
		(Boolean(visitStart) && !visitEnd);

	const timerVarians = {
		danger: 'light-danger',
		warning: 'light-warning',
		default: 'default',
	};

	const timerVariant = timerVarians[variant] as BasicCircleButtonVariant;

	return {
		hasTimer,
		timer,
		timerVariant,
	};
};
